import type { ListingPost } from '~/app/types/listingTypes';

/**
 * The getExcerpt helper function tries to return an excerpt.
 * It will first check if an excerpt has been provided in the CMS and return it, if not, it will try to create one from the content of the post, before returning an empty string.
 *
 *
 *
 */
export function getExcerpt(post: ListingPost) {
  let excerpt = '';

  if (post.excerpt) {
    // Post excerpt field already has a max length of 160 characters in the CMS, so we can return it straight away if it is present.
    excerpt = post.excerpt;
  }

  if (post.content) {
    if (post.content.length > 157) {
      // Trim to 157 characters
      let content = post.content.slice(0, 157);

      // Remove trailing space, if present
      if (content.charAt(content.length - 1) === ' ') {
        content = content.slice(0, -1);
      }

      // Append ellipsis
      content += '...';

      excerpt = content;
    }
  }

  return excerpt;
}
